import Vue from 'vue';
import Router from 'vue-router';
import store from 'src/store/store';
import componentObj from './component';
import serve from 'src/common/js/serve.js';
import {
    getMenuLists
} from 'src/api/common.api.js';
import hash from './hash.js';
import login from 'src/views/common/login/login.vue';
import home from 'src/views/common/home/home.vue';
// import bigScreen from 'src/components/big-screen/views/index.vue';

let asynComponent = componentObj;

// for (let key in asynComponent) {
//     if (asynComponent.hasOwnProperty(key)) {
//         Vue.component(key, asynComponent[key]);
//     }
// }

/**
 * [_fitlerSpeChar 过滤掉字符串中的 / 杆]
 */
function _fitlerSpeChar (str) {
    return str.replace('/', '');
}

function _fitlerSpeChar1 (str) {
    if (str.includes('/')) {
        return str;
    }
    return '/' + str;
}

/**
 * [_getMenu 异步获取菜单栏]
 */
function _getMenu (cb) {
    serve.http.httpRequest({}, getMenuLists, function (res) {
        _getRoute(res.menuList, cb);
    }, 5);
}

function _getRoute (menuLists, cb) {
    let route = [];

    if (menuLists.length !== 0) {
        menuLists.forEach(function (item) {
            let children = [],
                name = '',
                icon = '',
                comp = '';

            // 是否有子选项 true表示有子项
            if (item.list.length !== 0) {
                name = item.name;
                icon = item.icon;
                item.list.forEach(function (node) {
                    comp = _fitlerSpeChar(node.url);
                    children.push({
                        id: node.menuId,
                        path: _fitlerSpeChar1(node.url),
                        name: node.name,
                        comp: comp,
                        component: asynComponent[_fitlerSpeChar(node.url)]
                    });
                });
            } else {
                name = item.name;
                icon = item.icon;
            }

            route.push(
                {
                    path: '/home',
                    component: home,
                    name: name,
                    icon: icon,
                    children: children
                }
            );
        });
    }

    var cardPayLogRouteSeen = false;

    route.forEach(function (item) {
        if (!cardPayLogRouteSeen && item.path === '/home' && item.children && item.children.length > 0) {
            cardPayLogRouteSeen = true;
            var hasPayLog = item.children.some(function (c) {
                return c.comp === 'cardPayLog';
            });
            
            if (!hasPayLog) {
                item.children.push({
                    id: 'card-pay-log',
                    path: '/cardPayLog/:cardNo',
                    name: 'CardPayLog',
                    comp: 'cardPayLog',
                    component: asynComponent.cardPayLog,
                    hidden: true
                });
            }
        }
    });

    store.state.menu = route;
    cb(route);
}

function _getInitRoute () {
    let route = [];

    route.push(
        {
            path: '/',
            component: login,
            name: 'login',
            hidden: false,
            children: []
        }
        // {
        //     path: '/bigScreen',
        //     component: bigScreen,
        //     name: 'bigScreen',
        //     hidden: false,
        //     children: []
        // }
    );

    // store.state.menu = route;
    return route;
}

export default {
    getInitRoute: _getInitRoute,
    getMenu: _getMenu
};



// WEBPACK FOOTER //
// ./src/router/route.js